import Strike from '@tiptap/extension-strike';
import { menuControlFor } from './_get_menu_control';

const syncMenu = ({ editor }) => {
  const control = menuControlFor(editor, 'text:formatting', 'strike');
  const controlIsActive = editor.isActive('strike');

  control?.classList?.toggle('active', controlIsActive);
};

export default [
  Strike.extend({
    onSelectionUpdate: syncMenu,
    onTransaction: syncMenu,
  }),
];
